import { useState } from "react";
import { Formik } from "formik";
import BasePassword from "../../base/BasePassword";
import { Link } from "react-router-dom";
import BaseButton from "../../base/BaseButton";
import {
  validateResetPasswordDetails,
  ResetPasswordFormValues,
} from "../../../utils/validateSchema";
import ResetSuccessful from "../ResetSuccessful";
import OrgAuthLayout from "../OrgAuthLayout";
import { useSearchParams } from "react-router-dom";
import curlyHairImg from "../../../assets/img/curly_hair_girl.svg";
import { toast } from "react-toastify";
import { resetPasswordAction } from "../../../store/slices/auth/action";
import { useAppDispatch } from "../../../store";
import { BaseInput } from "../../base";
import { Platform } from "../../../enums/plaftorm.enum";

const ResetPasswordForm = () => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const [searchParams] = useSearchParams();

  const initialValues: ResetPasswordFormValues = {
    token: "",
    password: "",
    confirmPassword: "",
  };

  const onSubmit = async (values: ResetPasswordFormValues) => {
    const { password, token } = values;
    try {
      setIsProcessing(true);
      const res = await dispatch(
        resetPasswordAction({
          token,
          email: searchParams.get("email") as string,
          password,
          platform: Platform.OrganisationDashboard
        })
      );
      if (res.payload.status === 200) {
        toast.success(res?.payload?.message);
        setIsProcessing(false);
        setIsSuccessful(true);
      }

      if (res?.payload?.statusCode >= 400 && res?.payload?.statusCode < 500) {
        setIsProcessing(false);
        return toast.error(res.payload?.message);
      }
      if (res?.payload?.statusCode >= 500) {
        setIsProcessing(false);
        return toast.error("An unexpected error has occured! please try again");
      }
    } catch (error) {
      setIsProcessing(false);
    }
  };

  return (
    <OrgAuthLayout title="Reset Password" bgImage={curlyHairImg}>
      <div className="flex h-screen items-center overflow-y-scroll justify-center transition">
        <div className="text-center w-3/4 mx-auto  page-bg-padding mt-[-9rem]">
          {!isSuccessful ? (
            <div>
              <h3 className="text-[32px] font-medium text-[#2D2D31]">
                Set New Password
              </h3>
              <p className="text-gray-600 text-base py-4">
                Password must be at least 8 characters
              </p>
              {/* <p className="text-[#767B86]">Please enter your credentials to proceed.</p>*/}
              <div className="my-4">
                <Formik
                  initialValues={initialValues}
                  onSubmit={onSubmit}
                  validate={validateResetPasswordDetails}
                >
                  {(formik) => {
                    const {
                      values,
                      touched,
                      isValid,
                      dirty,
                      handleChange,
                      handleSubmit,
                      errors,
                      handleBlur,
                    } = formik;
                    return (
                      <form onSubmit={handleSubmit}>
                        <div className="mt-6"> 
                        <BaseInput
                          id={"token"}
                          value={values.token}
                          label="Reset Token"
                          name={"token"}
                          type="text"
                          hasError={errors.token && touched.token}
                          change={handleChange}
                          blur={handleBlur}
                          errorMsg={errors.token}
                        />
                        </div>
                       
                        <div className="mt-6">
                          <BasePassword
                            id={"password"}
                            value={values.password}
                            label="Create Password"
                            name={"password"}
                            hasError={errors.password && touched.password}
                            change={handleChange}
                            blur={handleBlur}
                            errorMsg={errors.password}
                          />
                        </div>
                        <div className="mt-6">
                          <BasePassword
                            id={"confirmPassword"}
                            value={values.confirmPassword}
                            label="Confirm Password"
                            name={"confirmPassword"}
                            hasError={
                              errors.confirmPassword && touched.confirmPassword
                            }
                            change={handleChange}
                            blur={handleBlur}
                            errorMsg={errors.confirmPassword}
                          />
                        </div>
                        <BaseButton
                          text="Reset Password"
                          variant="primary"
                          type="submit"
                          styles="w-full mt-4"
                          processing={isProcessing}
                          disabled={!(dirty && isValid)}
                        />
                      </form>
                    );
                  }}
                </Formik>
                <p className="flex justify-center mt-4">
                  <Link to={"/login"} className="pl-1 primary_text_color ">
                    Back to Log in
                  </Link>
                </p>
              </div>
            </div>
          ) : (
            <ResetSuccessful />
          )}
        </div>
      </div>
    </OrgAuthLayout>
  );
};

export default ResetPasswordForm;
